module.exports = __webpack_public_path__ + "static/media/HP_card_riverside.2ea1290e.jpg";